import { Component } from '@angular/core';
import { Camera, CameraOptions } from '@awesome-cordova-plugins/camera/ngx';
import { ResultProvider } from '../../../providers/result/result';
import { LoadingController,  NavController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserProvider } from '../../../providers/user/user';
import { TrackerModel, StrackerProvider } from '../../../providers/stracker/stracker';
import { EventDetailsModel } from '../../../providers/event/event';
import { AppDetectorProvider } from '../../../providers/detector/detector';
import { Router } from '@angular/router';

@Component({
    selector: 'page-result-add',
    templateUrl: 'result-add.html',
    styleUrls:['./result-add.scss']
})
export class ResultAddPage {
    model = {
        time: "00:00:00",
        photo: null
    };

    event: EventDetailsModel;
    token: string = "";

    obj: TrackerModel = {
        eventId: 0,
        token: "",
        time: 0,
        distance: 0,
        finished: true,
        average_pace: "0",
        average_speed: 0
        // path: [],
        // splited: []
    };

    imageLink = "./../../assets/imgs/default.png";
    placeholder = "00:00:00";
    data: TrackerModel;

    constructor(
        private camera: Camera,
        private resultService: ResultProvider,
        private router:Router,
        private loadingCtrl: LoadingController,
        private translate: TranslateService,
        private userService: UserProvider,
        private strackerService: StrackerProvider,
        private toastCtrl: ToastController,
        private detector: AppDetectorProvider,
        private navCtrl:NavController
    ) {
        const nav = this.router.getCurrentNavigation();
        const state = nav?.extras?.state || {};
        this.imageLink = state['imageLink'];
        this.event = state['event'];
        this.data = state['data'];
        this.token = state['token'];

        if (this.data) {
            this.placeholder = this.getCurrentDuration(this.data.time);
            this.model.time = this.placeholder;
        }
    }

    timeChanged() {
        console.log(this.model.time);
    }

    getCurrentDuration(sec) {
        let dur = sec;
        let result = "";
        let h = 0;
        let m = 0;

        if (dur >= 60) {
            m = Math.floor(dur / 60);
        }
        if (m >= 60) {
            h = Math.floor(m / 60);
        }

        result = (h < 10) ? "0" + h + ":" : h + ":";
        result += ((m % 60) < 10) ? "0" + m % 60 + ":" : (m > 59) ? (m % 60) + ":" : m + ":";
        result += ((dur % 60) < 10) ? "0" + (dur % 60) : (dur > 59) ? (dur % 60) : dur + "";

        return result;
    }

    async onSave() {
        if (this.model.time === "00:00:00") {
            let toast = await this.toastCtrl.create({
                message: this.translate.instant('EMPTY_TIME_MESSAGE'),
                duration: 3000,
                position: 'top'
            })
            toast.present();
            return;
        }

        let distance = Number(this.event.streckeconv.replace(',', '.').replace(/[a-zA-Z ]/g, "")) * 1000;
        console.log('distance: ' + distance);

        //@ ENDPOINT REMOVED: 27.04.2023
        // this.resultService.isTimeValid(this.event.cid, this.getTime(), distance).then((isValid) => {
        //     if (isValid) {
        //         this.obj.time = this.getTime();
        //         this.obj.eventId = this.event.id;
        //         this.obj.token = this.token;
        //         this.obj.distance = distance;
        //         this.obj.average_speed = this.obj.distance / (this.obj.time / 3600);
        //         this.obj.average_pace = (this.obj.time / (this.obj.distance / 1000)) + "";

        //         this.strackerService.pushDataFinished(this.obj);

        //         let activeResult: ActiveResult = {
        //             time: this.getTime(),
        //             eventId: this.event.id,
        //             cid: this.event.cid
        //         }

        //         this.resultService.sendVirtualResultsNoCheck({ timeSec: this.getTime(), cid: this.event.cid, eventId: this.event.id }).then(() => {
        //             this.openResults(activeResult);
        //         });
        //     } else {
        //         this.toastMessage(this.translate.instant("TIME_IS_NOT_VALID"), 5000);
        //     }

        // });

    }

    onUploadPhoto() {
        this.openCamera();
    }

    async openResults(activeResult) {
        var loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        this.userService.createPhoto(-1, this.model.photo, false).then(() => {
            this.userService.getMyResults(this.detector.isHellaApp() ? false : true).then(results => {
                if (this.detector.isHellaApp()) {
                    this.navCtrl.pop().then(()=>loader.dismiss());
                    // (this.app.getRootNav() as NavController).pop().then(() => loader.dismiss());
                } else {
                    this.navCtrl.navigateForward('/mysport-results', {state:{results: results, activeResult: activeResult}}).then(() => loader.dismiss());
                    // (this.app.getRootNav() as NavController).push(MysportResultsPage, { results: results, activeResult: activeResult }).then(() => loader.dismiss());
                }
            });
        });
    }

    getTime() {
        let time = this.model.time.split(':');
        let result = Number(time[0]) * 3600;
        result += Number(time[1]) * 60;
        result += Number(time[2]);
        return result;
    }

    async openCamera() {
        let loader = await this.loadingCtrl.create({
            message: this.translate.instant('GLOBAL_LOADING')
        });
        loader.present();

        const cameraOptions: CameraOptions = {
            quality: 100,
            destinationType: this.camera.DestinationType.DATA_URL,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE,
            sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
            correctOrientation: true
        };

        this.camera.getPicture(cameraOptions).then((imageData) => {
            console.log(imageData);
            // this.imageLink = 'data:image/jpeg;base64,' + imageData;
            let img = 'data:image/jpeg;base64,' + imageData;
            this.model.photo = img;

            loader.dismiss();
        }).catch((reason) => {
            loader.dismiss();
        });
    }

    toastMessage(message, duration, position:"top" | "bottom" | "middle" = "top") {
        this.toastCtrl.create({
            message: message,
            duration: duration,
            position: position
        }).then(toast=>toast.present());
    }
}

export interface ActiveResult {
    eventId: number;
    time: number;
    cid: number;
}
